<template>
  <div class='piano'>
    <div class="naturals-container" >
      <button v-bind:style="{ backgroundColor: btn0 }" v-on:click="changeColor(0), playnotes(1)" ><p>C</p></button> <!--v-on:click is imperative because it is attached to an event listener-->
      <button :style="{ backgroundColor: btn1 }" v-on:click="changeColor(1), playnotes(3)" ><p>D</p></button> <!--v-bind:style is delcaritive because its just telling to component how to look-->
      <button :style="{ backgroundColor: btn2 }" v-on:click="changeColor(2), playnotes(5)" ><p>E</p></button>
      <button :style="{ backgroundColor: btn3 }" v-on:click="changeColor(3), playnotes(6)" ><p>F</p></button>
      <button :style="{ backgroundColor: btn4 }" v-on:click="changeColor(4), playnotes(8)" ><p>G</p></button>
      <button :style="{ backgroundColor: btn5 }" v-on:click="changeColor(5), playnotes(10)" ><p>A</p></button>
      <button :style="{ backgroundColor: btn6 }" v-on:click="changeColor(6),playnotes(12)" ><p>B</p></button>
    </div>
    <div class="accidentals-container">
        <button class="C" v-on:click="playnotes(2)" ><h3>C#/Db</h3></button>
        <button class="D" v-on:click="playnotes(4)" ><h3>D#/Eb</h3></button>
        <button class="F" v-on:click="playnotes(7)" ><h3>F#/Gb</h3></button>
        <button class="G" v-on:click="playnotes(9)" ><h3>G#/Ab</h3></button>
        <button class="A" v-on:click="playnotes(11)"><h3>A#/Bb</h3></button>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      btn0: "white",
      btn1: "white",
      btn2: "white",
      btn3: "white",
      btn4: "white",
      btn5: "white",
      btn6: "white",
      colors: ["salmon", "pink", "purple"],
      timeout: {}
    };
  },
  methods: {
    playnotes(index) {
      const audio = new Audio();
      audio.src = [`piano${index}.mp3`]; //another way to concatenate strings '/note' + index + '.mp3'; may not always result in a string, used to perform operations
      audio.load();
      audio.play();
    },
    changeColor(index) {
      clearTimeout(this.timeout[index]); //this clears any exisitng timeout, keeps the button from changing back to white if it is clicked mulitple times during the timeout period
      this[`btn${index}`] = this.colors[index % this.colors.length]; // % makes sure the the color index is always in the bounds of the array
      this.timeout[index] = setTimeout(() => { //the timeout property is an array that keeps track of the timeouts for each button so each button can have its own separarte timeout
        this[`btn${index}`] = "white";
      }, 500);
    }
  }
};
</script>


<style scoped >

body{
    margin: 0;
    min-height: 100vh;
    
}
.piano{
  width: 800px;
  height: 300px;
  display: inline-block;
}
h3{
    color: white;
}
.accidentals-container {
  width: 800px;
  display: grid;
  grid-template-columns: repeat(42, 1fr); /*!--42 equal width columns 1 fraction of the space--> */
  height: 66%;
  justify-items: center;
}
.accidentals-container button {
  width: 58px;
  border: 1px solid #fff;
  border-radius: 0 0 4px 4px;
  cursor: pointer;
  top: -399px;
  position: relative;
  /* z-index: 1; */
  border-top: none;
}
.accidentals-container button.C {
  grid-column: 6 / span 2; /* in column 6 and spans over 2 columns 6 and 7 */
  background-color: #1B2631;
}

.accidentals-container button.D {
  grid-column: 12 / span 3;
  background-color: #2C3E50;
}

.accidentals-container button.F {
  grid-column: 25 / span 2;
  background-color: #1B2631;
}

.accidentals-container button.G {
  grid-column: 31 / span 2;
  background-color: #2C3E50;
}

.accidentals-container button.A {
  grid-column: 37 / span 1;
  background-color: #1B2631;
}


.naturals-container {
  width: 800px;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  height: 400px;
}
.naturals-container button {
  cursor: pointer;
}
h1{
    color: white;
   
}

</style>